/**
 * ColaAtencionFilters — Filtros de la cola de atención.
 * Filtra por tipo de servicio.
 *
 * Requirements: M4.1.5
 */

import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { TipoServicio } from "@/hooks/use-muestras";

interface ColaAtencionFiltersProps {
  tipoServicio: TipoServicio | undefined;
  onTipoServicioChange: (value: TipoServicio | undefined) => void;
}

const TIPOS_SERVICIO: { value: TipoServicio; label: string }[] = [
  { value: "AMBULATORIO", label: "Ambulatorio" },
  { value: "HOSPITALIZACION", label: "Hospitalización" },
  { value: "EMERGENCIA", label: "Emergencia" },
  { value: "DOMICILIO", label: "Domicilio" },
];

export function ColaAtencionFilters({
  tipoServicio,
  onTipoServicioChange,
}: ColaAtencionFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3">
      <Select
        value={tipoServicio ?? "all"}
        onValueChange={(val) =>
          onTipoServicioChange(val === "all" ? undefined : (val as TipoServicio))
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder={t("muestras.cola.tipo_servicio")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t("muestras.cola.todos_los_servicios")}</SelectItem>
          {TIPOS_SERVICIO.map((tipo) => (
            <SelectItem key={tipo.value} value={tipo.value}>
              {tipo.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
